module.exports = __webpack_public_path__ + "h5/img/smrenz.368f79f8.png";